import DOMPurify from 'isomorphic-dompurify';
import { SquareCheckBigIcon } from 'lucide-react';
import React from 'react';

interface FormSuccessProps {
    message?: string;
    icon?: React.ReactNode;
    classes?: string;
}

export function FormSuccess({ message, icon, classes }: FormSuccessProps) {
    if (!message) {
        return null;
    }
    return (
        <div
            id='form_success'
            className={`flex flex-col items-center w-full gap-2 rounded-md bg-emerald-600/15 p-3 text-sm text-emerald-600 dark:bg-emerald-400/15 dark:text-emerald-300 ${classes}`}>
            {icon ? icon : <SquareCheckBigIcon className='size-6' />}
            <p
                className='text-center text-[0.9rem] md:text-[1rem]'
                dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(message, {
                        USE_PROFILES: { html: true },
                    }),
                }}></p>
        </div>
    );
}
